import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link as ReactRouterLink } from 'react-router-dom'
import noop from 'lodash/noop'

class Link extends PureComponent {
  handleClick = (event) => {
    event.preventDefault()
    this.props.onClick(event)
  }

  render() {
    const {
      className: extraClassName,
      children: contentElement,
      intlId,
      intlProps,
      href,
      to,
      onClick,
      defaultColor,
      innerRef,
      ...rest
    } = this.props

    const className = `dib link pointer ${
      defaultColor ? 'c-action-primary hover-c-action-primary' : ''
    } ${extraClassName}`

    const children = contentElement || (
      <FormattedMessage id={intlId} {...intlProps} />
    )

    return to ? (
      <ReactRouterLink
        className={className}
        to={to}
        onClick={onClick}
        {...rest}
      >
        {children}
      </ReactRouterLink>
    ) : (
      <a
        className={className}
        href={href}
        onClick={href ? onClick : this.handleClick}
        ref={innerRef}
        {...rest}
      >
        {children}
      </a>
    )
  }
}

Link.defaultProps = {
  className: '',
  defaultColor: true,
  onClick: noop,
}

Link.propTypes = {
  className: PropTypes.string,
  defaultColor: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  children: PropTypes.node,
  intlId: PropTypes.string,
  intlProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // react-router
}

export default Link
